// src/features/landing/domain/rbBridgeConsult.js
// RB Bridge 상담 신청(매수자 · 매도자 · 파트너스) 공용 상수·검증.
// 사용처: /rb-bridge 상담 박스(RbBridgeConsultSection), 신청 페이지(RbBridgeConsultPage, /rb-bridge/consult/:slug)

export const RB_BRIDGE_KAKAO_URL = "http://pf.kakao.com/_Tdzxen";
export const RB_BRIDGE_TEL = "02-858-2014";

export const RB_BRIDGE_CONSULT_TYPES = [
    {
        slug: "buyer",
        type: "BUYER",
        label: "매수자 상담",
        en: "For Buyers",
        title: "지사 인수를 검토하고 있습니다",
        body: "운영팀이 검수한 조직만 검토하고, NDA 후 실적·수수료 흐름 등 상세 정보를 확인합니다.",
        lead: "검수를 거친 조직만, NDA 이후에 상세 정보를 확인하실 수 있습니다. 인수 목적과 규모를 첫 상담에서 함께 정리합니다.",
        tone: "orange",
    },
    {
        slug: "seller",
        type: "SELLER",
        label: "매도자 상담",
        en: "For Sellers",
        title: "지사 양도를 검토하고 있습니다",
        body: "조직명·실명 없이 시작합니다. 조직을 특정할 수 없는 요약만 인증된 인수자에게 보입니다.",
        lead: "조직명과 실명 없이 시작하실 수 있습니다. 조직을 특정할 수 있는 정보는 어느 단계에서도 동의 없이 공개되지 않습니다.",
        tone: "brown",
    },
    {
        slug: "partner",
        type: "PARTNER",
        label: "파트너스 상담",
        en: "For Partners",
        title: "RB Bridge와 함께하고 싶습니다",
        body: "법무·세무·노무 등 전문 파트너, 지사 거래를 소개해 주실 분과 협업 방식을 안내합니다.",
        lead: "법무·세무·노무 등 전문 파트너, 지사 거래를 소개해 주실 분을 찾고 있습니다. 협업 방식과 조건은 상담에서 안내드립니다.",
        tone: "ink",
    },
];

export const findConsultType = (slug) => RB_BRIDGE_CONSULT_TYPES.find((c) => c.slug === slug);

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const formatPhone = (raw) => {
    if (!raw) return "";
    const d = raw.replace(/\D/g, "").slice(0, 11);
    if (d.startsWith("02")) {
        if (d.length <= 2) return d;
        if (d.length <= 5) return `${d.slice(0, 2)}-${d.slice(2)}`;
        if (d.length <= 9) return `${d.slice(0, 2)}-${d.slice(2, 5)}-${d.slice(5)}`;
        return `${d.slice(0, 2)}-${d.slice(2, 6)}-${d.slice(6, 10)}`;
    }
    if (d.length <= 3) return d;
    if (d.length <= 6) return `${d.slice(0, 3)}-${d.slice(3)}`;
    if (d.length <= 10) return `${d.slice(0, 3)}-${d.slice(3, 6)}-${d.slice(6)}`;
    return `${d.slice(0, 3)}-${d.slice(3, 7)}-${d.slice(7)}`;
};

export function validateConsultForm(form) {
    const errors = {};
    if (!form.name.trim()) errors.name = "이름을 입력해 주세요.";
    const digits = form.phone.replace(/\D/g, "");
    if (!digits) errors.phone = "연락처를 입력해 주세요.";
    else if (digits.length < 9) errors.phone = "연락처를 정확히 입력해 주세요.";
    if (!form.email.trim()) errors.email = "이메일을 입력해 주세요.";
    else if (!EMAIL_RE.test(form.email.trim())) errors.email = "이메일 형식을 확인해 주세요.";
    if (!form.privacyAgreed) errors.privacyAgreed = "개인정보 수집·이용에 동의해 주세요.";
    if (!form.serviceAgreed) errors.serviceAgreed = "서비스 이용약관에 동의해 주세요.";
    return errors;
}

export function readUtm() {
    try {
        const q = new URLSearchParams(window.location.search);
        return {
            utmSource: q.get("utm_source") || undefined,
            utmMedium: q.get("utm_medium") || undefined,
            utmCampaign: q.get("utm_campaign") || undefined,
        };
    } catch {
        return {};
    }
}
